import { faChevronLeft, faChevronRight, faCircleNotch } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, IconButton, Typography, useTheme } from "@mui/material"
import { StyledButtonGroupSwitch, StyledButtonSwitch } from "components/ButtonSwitch/ButtonSwitch"
import { allRoutes } from "generated/routes"
import { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { IVehicleSwiperProps, Vehicle } from "./VehicleSwiper.interfaces"
import InfoTooltip from "components/Tooltip/InfoTooltip"

const VehicleSwiper = ({ vehiclesList, vehicleDetails, loadingState, toolTipText }: IVehicleSwiperProps) => {
  const history = useHistory()
  const [currentIndex, setCurrentIndex] = useState(0)
  const [viewType, setViewType] = useState<string>("regNumber")
  const theme = useTheme()
  const [activeVehicle, setActiveVehicle] = useState<Vehicle | null>(null)

  useEffect(() => {
    if (vehiclesList.length && vehicleDetails?.id) {
      const vehicleIndex = vehiclesList.findIndex((v) => v.id === vehicleDetails.id)
      if (vehicleIndex !== -1) {
        setCurrentIndex(vehicleIndex)
        setActiveVehicle(vehiclesList[vehicleIndex])
      }
    }
  }, [vehiclesList, vehicleDetails])

  const wrapIndex = (i: number) => (i + vehiclesList.length) % vehiclesList.length

  const updateToIndex = (i: number) => {
    const newIndex = wrapIndex(i)
    setCurrentIndex(newIndex)
    setActiveVehicle(vehiclesList[newIndex])
    const newVehicleId = vehiclesList[newIndex].id
    history.push(allRoutes.VehicleregistryVehiclesDetails(newVehicleId))
  }

  const goToNext = () => updateToIndex(currentIndex + 1)
  const goToPrevious = () => updateToIndex(currentIndex - 1)

  const previousVehicle = vehiclesList.length > 0 ? vehiclesList[wrapIndex(currentIndex - 1)] : null
  const nextVehicle = vehiclesList.length > 0 ? vehiclesList[wrapIndex(currentIndex + 1)] : null

  const viewList = activeVehicle
    ? [
      { id: "regNumber", label: activeVehicle.regNumber },
      { id: "internnumber", label: activeVehicle.internnumber }
    ]
    : []

  return (
    activeVehicle === null ? (<FontAwesomeIcon spin icon={faCircleNotch} size="1x" color={(theme.palette["primary"].dark)} />
    ) :
      <Box display="flex" alignItems="center" gap={0.5}>
        <Typography variant="bodySmall" color="textSecondary">
          {(previousVehicle as any)?.[viewType] ?? ""}
        </Typography>

        <Box display="flex" alignItems="center" gap={0.5}>
          <IconButton sx={{ width: "30px" }} onClick={goToPrevious} size="small" aria-label="previous">
            <FontAwesomeIcon icon={faChevronLeft} color={(theme.palette["primary"].dark)} />
          </IconButton>

          <StyledButtonGroupSwitch
            sx={{ height: "auto" }}
            variant="outlined"
            color="inherit"
            size="medium"
          >
            {viewList.map(({ id, label }) => (
              <StyledButtonSwitch
                sx={{ height: "40px" }}
                key={id}
                onClick={() => setViewType(id)}
                active={viewType === id}
              >
                <Typography variant="bodySmall" fontWeight={viewType === id ? 600 : 400}>
                  {loadingState !== 2 ? (
                    <FontAwesomeIcon spin icon={faCircleNotch} size="1x" />
                  ) : (
                    label
                  )}
                </Typography>
              </StyledButtonSwitch>
            ))}
          </StyledButtonGroupSwitch>


          <IconButton sx={{ width: "30px" }} onClick={goToNext} size="small" aria-label="next">
            <FontAwesomeIcon icon={faChevronRight} color={(theme.palette["primary"].dark)} />
          </IconButton>
        </Box>

        <Typography variant="bodySmall" color="textSecondary">
          {(nextVehicle as any)?.[viewType] ?? ""}
        </Typography>

        {toolTipText && <InfoTooltip key={vehicleDetails.id} title={toolTipText} />}
      </Box>
  )

}

export default VehicleSwiper
